import { Button, CircularProgress } from "@mui/material";
import { Session } from "../../../../types/records.types";
import { SimpleUser } from "../../../../types/user.types";
import { FOLLOWUP_SERVICE } from "../../../../utils/constants";
import { useUpdateMeetingCache } from "../../utils";
import { MeetingURLButton } from "./MeetingURLButton";
import { SendMeetingButton } from "./SendMeetingButton";
import { useCheckAutoMeetingSent } from "./useCheckAutoMeetingSent";

export interface ExtendedSessionType extends Session {
    treatment: Session["treatment"] & {
        client: {
            user_id: SimpleUser;
        };
    };
}

type OnlineSessionProps = {
    session: ExtendedSessionType;
};
export const OnlineSession = ({session}: OnlineSessionProps) => {
    const updateMeetingCache = useUpdateMeetingCache(session.id);
    const { isCheckingAutoMeeting } = useCheckAutoMeetingSent({ session });
    const meetingName = !session?.service?.id || session?.service?.id === FOLLOWUP_SERVICE ? "Reunião" : "Consulta"

    const gracePeriod = 3 * 60 * 60 * 1000;
    const sessionExpired = Date.now() > new Date(session.start_date).getTime() + gracePeriod
    const hasMeetingId = !!session.meeting_id;


    const showSendMeetingButton = !hasMeetingId && !sessionExpired;
    const showMeetingURLButton = hasMeetingId && !sessionExpired;

    if (isCheckingAutoMeeting) return <Button size="large" disableElevation disabled><CircularProgress color="inherit" size={20} /></Button>;
    if (showMeetingURLButton) return  <MeetingURLButton session={session} updateMeetingCache={updateMeetingCache} meetingName={meetingName}/>
    if (showSendMeetingButton) return <SendMeetingButton session={session} updateMeetingCache={updateMeetingCache} meetingName={meetingName}/>
    return null;
};
